import React from 'react';
import { motion } from 'framer-motion';
import { clientLogos } from '../../lib/constants';

const FinalCTA = ({ onScheduleCall }) => {
  return (
    <section className="relative py-20 md:py-32 bg-black text-white overflow-hidden">
      <motion.div
        className="absolute inset-0 opacity-20"
        animate={{
          background: [
            'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 80% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
            'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          ]
        }}
        transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
      />

      <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
        <motion.h2
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold mb-4 md:mb-6"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Ready to Build Something Exceptional?
        </motion.h2>

        <motion.p
          className="text-lg sm:text-xl md:text-2xl text-neutral-300 mb-8 md:mb-12 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          Join startups like Saturdays.com and Happyfresh who trust Arabica as their design partner.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <motion.button
            className="relative px-8 md:px-12 py-4 md:py-6 text-base md:text-xl font-bold bg-white text-black rounded-full overflow-hidden"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={onScheduleCall}
          >
            <motion.div
              className="absolute inset-0 bg-white opacity-50 rounded-full"
              animate={{
                scale: [1, 1.5, 1],
                opacity: [0.5, 0, 0.5]
              }}
              transition={{ duration: 2, repeat: Infinity }}
            />
            <span className="relative z-10">Book Your Strategy Call</span>
          </motion.button>
        </motion.div>

        <motion.p
          className="mt-4 md:mt-6 text-sm md:text-base text-neutral-400"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3 }}
        >
          30-minute strategy call • No commitment • Just value
        </motion.p>

        <motion.div
          className="flex flex-wrap justify-center gap-6 md:gap-8 mt-8 md:mt-12"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          {clientLogos.slice(0, 5).map((logo, index) => (
            <motion.div
              key={index}
              className="w-32 h-16 bg-white/5 rounded-xl hover:bg-white/10 transition-all flex items-center justify-center border border-white/10 p-3"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.4 + index * 0.1 }}
              whileHover={{ scale: 1.05, y: -4 }}
            >
              {logo.src ? (
                <img
                  src={logo.src}
                  alt={logo.alt}
                  className="max-w-full max-h-full object-contain opacity-70 hover:opacity-100 transition-opacity"
                />
              ) : (
                <span className="text-white font-semibold text-sm opacity-70 hover:opacity-100 transition-opacity">
                  {logo.alt}
                </span>
              )}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;